import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, SetFilterQuery } from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetFilterQuery";

addToChainBefore(chain, SetFilterQuery, props => {
    props.dispatch({
        type: "Custom/ProductList/SetFilterLoading",
        isLoadingFilter: true,
    } as any);
});
